<template>
  <div
    class="w-full fixed top-14 left-0 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1)] bg-white z-50 p-2.5"
  >
    <div
      class="flex items-center sm:space-x-3.5 space-x-2.5 max-w-7xl mx-auto lg:px-5 px-2.5"
    >
      <ProfileAvatar
        text="sm:text-base text-base"
        :user="user"
        size="sm:size-10 sm:min-w-10 size-9 min-w-9"
      />
      <div class="flex flex-col -space-y-1">
        <p class="font-semibold sm:text-lg text-base">
          {{ user?.name }} {{ user?.last_name }}
        </p>
        <p
          v-if="user.createdAt"
          class="text-gray-500 sm:text-xs text-[11px] italic"
        >
          {{ new Date(user.createdAt).getFullYear() }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  user: any | null;
}>();
</script>
